import { render } from "./TaskEdit.vue?vue&type=template&id=7a5a1662&scoped=true"
import script from "./TaskEdit.vue?vue&type=script&lang=js"
export * from "./TaskEdit.vue?vue&type=script&lang=js"

import "./TaskEdit.vue?vue&type=style&index=0&id=7a5a1662&scoped=true&lang=css"

import exportComponent from "/home/falken/code/web/ipronet-vsaas/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a5a1662"]])

export default __exports__